<template>
  <div>
    <b-form-group :label="label">
      <div
        :class="{'desabilitar-inputs': disabled}"
        style="display: inline;"
      >
        <file-upload
          ref="upload"
          v-model="value"
          :style="disabled ? 'opacity:0.5' : ''"
          :input-id="idUpload"
          class="btn btn-primary btn-sm mr-50"
          :accept="certificado ? '.pfx' : ''"
          :multiple="false"
          @input="selecionado"
          @input-filter="inputFilter"
        >
          <i class="fas fa-plus" />
          Carregar
        </file-upload>
      </div>
      <b-btn
        v-if="showVisualizacao"
        :disabled="!textArquivo"
        variant="none"
        size="sm"
        class="btn-outline-primary btn-none mr-50"
        @click="visualizarArquivo"
      >
        <feather-icon icon="ExternalLinkIcon" />
      </b-btn>
      <b-btn
        v-else
        :disabled="!textArquivo"
        variant="none"
        size="sm"
        class="btn-outline-primary btn-none mr-50"
        @click="baixarArquivo"
      >
        <font-awesome-icon :icon="faCloudDownloadAlt" />
      </b-btn>
      <b-btn
        :disabled="(disabled) || (!fileName && !textArquivo)"
        variant="none"
        size="sm"
        class="btn-outline-danger btn-none"
        @click="removeArquivo()"
      >
        <feather-icon icon="TrashIcon" />
      </b-btn>
    </b-form-group>
    <strong v-if="value[0] || textArquivo">Arquivo: {{ textArquivo ? textArquivo : value[0].name }}</strong>

    <visualizar-arquivo
      v-if="mostrarVisualizacao"
      :url="url"
      @hidden="fecharVisualizarArquivo()"
    />
  </div>
</template>

<style lang="scss">
.desabilitar-inputs {
  pointer-events: none;
}
</style>

<script>
import FileUpload from 'vue-upload-component'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faCloudDownloadAlt,
} from '@fortawesome/free-solid-svg-icons'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  name: 'UploadVisualizacaoParametrizacao',
  components: {
    FileUpload,
    FontAwesomeIcon,
    FeatherIcon,
    VisualizarArquivo: () => import('@/shared/components/visualizar-arquivo/VisualizarArquivo.vue'),
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    idUpload: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    visualizar: {
      type: Function,
      required: true,
    },
    certificado: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showVisualizacao: {
      type: Boolean,
      default: true,
    },
    // eslint-disable-next-line vue/require-default-prop, vue/require-prop-types
    valueCertificado: {
    },
  },
  data() {
    return {
      faCloudDownloadAlt,
      fileName: '',
      value: [],
      url: '',
      mostrarVisualizacao: false,
      valueAttr: '',
    }
  },
  computed: {
    textArquivo: {
      get() {
        return this.valueAttr ? this.valueAttr : this.text
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
  },
  watch: {
    text(val, oldVal) {
      if (val !== oldVal) {
        this.valueAttr = val
      }
    },
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      const file = newFile
      if (file) {
        if (this.isDangerFile(file.name)) {
          this.$erro('Arquivo não permitido')
          return prevent()
        }

        if (this.certificado && !this.allowExtension(file.name, 'pfx|PFX|p12|P12')) {
          this.$erro('Apenas arquivo pfx é permitido')
          return prevent()
        }
      }
      return null
    },
    visualizarArquivo() {
      this.visualizar()
        .then(payload => {
          if (payload.data) {
            this.url = payload.data
            this.mostrarVisualizacao = true
          }
        })
    },
    fecharVisualizacaoArquivo() {
      this.url = ''
      this.mostrarVisualizacao = false
    },
    selecionado() {
      if (this.value[0]) {
        this.textArquivo = ''
        this.fileName = this.value[0].name
        this.$emit('selecionado', this.fileName)
      } else {
        this.fileName = ''
      }
    },
    removeArquivo() {
      if (this.value[0]) {
        this.$refs.upload.remove(this.value[0])
      }
      this.fileName = ''
      this.urlArquivo = ''
      this.textArquivo = ''
      this.$emit('removido')
    },
    fecharVisualizarArquivo() {
      this.mostrarVisualizacao = false
    },
    isDangerFile(fileName) {
      if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(fileName)) {
        return true
      }
      // Filter php html js file
      if (/\.(php5?|html?|jsx?)$/i.test(fileName)) {
        return true
      }

      return false
    },
    allowExtension(fileName, extensions) {
      const regex = new RegExp(`^.*\\.(${extensions})$`)
      if (!regex.test(fileName)) {
        return false
      }
      return true
    },
    baixarArquivo() {
      const binary = atob(this.valueCertificado)
      const array = []
      for (let i = 0; i < binary.length; i += 1) {
        array.push(binary.charCodeAt(i))
      }
      const file = new Blob([new Uint8Array(array)], { type: 'application/pfx' })
      this.download(file)
    },
    download(file) {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(file)
      const fileName = this.text
      link.download = fileName
      document.body.appendChild(link)
      link.style.display = 'none'
      link.click()
      link.remove()
    },
  },
}
</script>
